import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Footer.css";
import Icon1 from "../../images/payment  (1).png";
import Icon2 from "../../images/payment  (3).png";
import Icon4 from "../../images/payment  (4).png";
import Icon5 from "../../images/payment  (5).png";
import Icon6 from "../../images/bank-logo-2.png";
import Icon7 from "../../images/cashfreeLogo.png";
import Logo from "../../images/procure-g-logo.png";
import { Link } from "react-router-dom";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import NewsletterImg from "../../images/banner-3 1.png";
import {
  subscribe,
  unsubscribe,
  getSubscriptionStatus,
} from "../../actions/userActions";
import { toast } from "react-toastify";
// newsletter
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import {
  LinkedIn,
  LocalPhone,
  WhatsApp,
  YouTube,
} from "@mui/icons-material";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const { user } = useSelector((state) => state.authState);
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkSubscriptionStatus = async (value) => {
    const emailValue = value.trim().toLowerCase();

    if (!emailValue) {
      setIsSubscribed(false);
      return;
    }

    try {
      setCheckingStatus(true);

      const data = await dispatch(
        getSubscriptionStatus(emailValue)
      );

      setIsSubscribed(data.subscribed === true);
    } catch (error) {
      console.error("Subscription status error:", error);
      setIsSubscribed(false);
    } finally {
      setCheckingStatus(false);
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;

    setEmail(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value.trim())) {
      checkSubscriptionStatus(value);
    } else {
      setIsSubscribed(false);
    }
  };

  const handleSubscription = async () => {
    if (!email.trim()) {
      return toast.error("Please enter a valid email");
    }

    try {
      setLoading(true);

      const normalizedEmail = email.trim().toLowerCase();

      if (isSubscribed) {
        await dispatch(unsubscribe(normalizedEmail));

        setIsSubscribed(false);
      } else {
        await dispatch(subscribe(normalizedEmail));

        setIsSubscribed(true);
      }

      setEmail("");
    } catch (error) {
      // Toast already handled inside Redux action
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="newsLetterSection mt-5">
        <div className="container-fluid">
          <div className="box d-flex align-items-center">
            <div className="info">
              <h2>
                Shop Smart, Shop Global
                <br />
                Glocre Private Limited Delivers to You!
              </h2>
              <p>
                Official or personal, shop everything <br />
                you need with us
              </p>
              <br />

              <div className="des-input">
                <div className="input-wrapper">
                  <SendOutlinedIcon className="input-icon" />
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
                
                 <button
                  className="subscribe-button"
                  onClick={handleSubscription}
                  disabled={loading || checkingStatus}
                >
                  {loading || checkingStatus
                    ? "Please wait..."
                    : isSubscribed
                    ? "Unsubscribe"
                    : "Subscribe"}
                </button>
              </div>
                <small className="subscription-hint">
                  To unsubscribe: Enter your email and click on Unsubscribe.
                </small>
            </div>

            <div className="img">
              <img src={NewsletterImg} className="w-100" alt="Newsletter" />
            </div>
          </div>
        </div>
      </section>

      <div className="footerWrapper">
        <footer>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3 part1">
                <Link to="/">
                  <img src={Logo} className="mb-3" alt="Logo" />
                </Link>
                <br />
                <p>
                  <strong style={{ fontSize: '20px' }}>
                    Glocre Private Limited
                  </strong>
                </p>

                <p>
                  <WatchLaterOutlinedIcon />
                  &nbsp;{' '}
                  <strong>
                    <span>Customer Care : </span>
                  </strong>
                  <span>
                    9:00 AM to 5:00 PM <br />
                    (IST) Monday to Saturday.
                  </span>
                </p>

                <p>
                  <LocalPhone />
                  &nbsp;{' '}
                  <strong>
                    <span>Call Us : </span>
                  </strong>
                  <span>(+91) 42222 11853</span>
                </p>

                <p>
                  <HeadphonesOutlinedIcon />
                  &nbsp;{' '}
                  <strong>
                    <span>Text Us : </span>
                  </strong>
                  <span>(+91) 86081 11853</span>
                </p>

                <p>
                  <EmailOutlinedIcon />
                  &nbsp;{' '}
                  <strong>
                    <span>Email : </span>
                  </strong>
                  <span>support@glocre.com</span>
                </p>
              </div>

              <div className="col-md-9 part2">
                <div className="row">
                  <div className="col">
                    <h3>
                      Glocre Private Limited
                      <hr style={{ width: '80%' }}></hr>
                    </h3>

                    <ul class="footer-list mb-sm-5 mb-md-0">
                      <li>
                        <Link to="/ourbusiness">Who We Are</Link>
                      </li>
                      <li>
                        <Link to="/policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/return">Return Policy</Link>
                      </li>
                      <li>
                        <Link to="/Shippingpolicy"> Shipping Policy </Link>
                      </li>
                      <li style={{ position: 'relative' }}>
                        <Link to="/announcements" className="announcement-link">
                          Announcements
                          {/* <span className="announcement-badge">3</span> */}
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col">
                    <h3>
                      Let Us Help You
                      <hr style={{ width: '80%' }}></hr>
                    </h3>
                    <ul class="footer-list mb-sm-5 mb-md-0">
                      <li>
                        <Link to="/myprofile">My Profile</Link>
                      </li>
                      <li>
                        <Link to="/faqs">FAQ's</Link>
                      </li>
                      {/* <li>
                        <Link to="/return">Cancellation &amp; Return</Link>
                      </li> */}
                      <li>
                        <Link to="/support">Customer Services</Link>
                      </li>
                      <li>
                        <Link to="/terms">Terms &amp; Conditions</Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col">
                    <h3>
                      Sell with Us
                      <hr style={{ width: '80%' }}></hr>
                    </h3>
                    <ul class="footer-list mb-sm-5 mb-md-0">
                      <li>
                        <Link to="/becomeseller">Sell on Glocre</Link>
                      </li>
                      <li>
                        <Link to="/support">Advertise Your Products</Link>
                      </li>
                      <li>
                        <Link
                          to={
                            user?.role === 'seller'
                              ? '/seller/dashboard'
                              : '/becomeseller'
                          }
                        >
                          Track Your Sales
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div className="row lastStrip gy-3 align-items-center">
              {/* LEFT SIDE */}
              <div className="col-12 col-lg-5 part3 part_3">
                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-center justify-content-center justify-content-lg-start text-center text-lg-start gap-3">
                  <h5 className="mb-0 payment-title">Payment Options:</h5>

                  <ul className="list-inline d-flex flex-wrap justify-content-center justify-content-lg-start align-items-center mb-0 p-0 gap-2">
                    <li className="list-inline-item m-0">
                      <img
                        src={Icon1}
                        className="paymentIcon"
                        alt="payment-icon-1"
                      />
                    </li>

                    <li className="list-inline-item m-0">
                      <img
                        src={Icon2}
                        className="paymentIcon"
                        alt="payment-icon-2"
                      />
                    </li>

                    <li className="list-inline-item m-0">
                      <img
                        src={Icon4}
                        className="paymentIcon"
                        alt="payment-icon-3"
                      />
                    </li>

                    <li className="list-inline-item m-0">
                      <img
                        src={Icon5}
                        className="paymentIcon upiIcon"
                        alt="payment-icon-4"
                      />
                    </li>

                    <li className="list-inline-item m-0">
                      <img
                        src={Icon6}
                        className="paymentIcon"
                        alt="payment-icon-5"
                      />
                    </li>

                    <li className="list-inline-item m-0">
                      <img
                        src={Icon7}
                        className="paymentIcon"
                        alt="payment-icon-6"
                      />
                    </li>
                  </ul>
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-12 col-lg-7 part_1">
                <ul className="list-inline d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end text-center text-lg-end mb-0 footerInfo gap-2">
                  <li className="list-inline-item m-0">
                    <p className="mb-0">CIN: U27320TZ2026PTC038410</p>
                  </li>

                  <li className="d-none d-md-inline">|</li>

                  <li className="list-inline-item m-0">
                    <p className="mb-0">GSTIN: 33AAMCG8942L1Z1</p>
                  </li>

                  <li className="d-none d-md-inline">|</li>

                  <li className="list-inline-item m-0">
                    <p className="mb-0">UDYAM-TN-03-0316959</p>
                  </li>

                  <li className="d-none d-md-inline">|</li>

                  <li className="list-inline-item m-0">
                    <p className="mb-0">DUNS 772365182</p>
                  </li>
                </ul>
              </div>
            </div>
            <hr />

            <div className="row lastStrip">
              <div className="col-md-6 part_1 d-flex align-items-center justify-content-center justify-content-md-start text-center text-md-start mb-2 mb-md-0">
                <p className="mb-0">
                  Copyright © {currentYear} GLOCRE All rights reserved.
                </p>
              </div>

              <div className="col-md-6 part3 part_3">
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-md-end text-center text-md-end w-100">
                  <h5 className="mb-2 mb-sm-0 me-sm-2">Follow Us:</h5>
                  <ul className="list list-inline d-flex justify-content-center justify-content-md-end align-items-center mb-0 pl-0">
                    <li className="list-inline-item mx-2">
                      <a
                        href="https://www.facebook.com/people/Glocre/61587032193264/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FacebookOutlinedIcon />
                      </a>
                    </li>
                    <li className="list-inline-item mx-2">
                      <a
                        href="https://whatsapp.com/channel/0029VbB7hMn3GJOxE5RwIt0l"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsApp />
                      </a>
                    </li>

                    <li className="list-inline-item mx-2">
                      <a
                        href="https://www.instagram.com/glocre_com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <InstagramIcon />
                      </a>
                    </li>

                    <li className="list-inline-item mx-2">
                      <a
                        href="https://www.youtube.com/@glocre"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <YouTube />
                      </a>
                    </li>

                    <li className="list-inline-item mx-2">
                      <a
                        href="https://www.linkedin.com/company/glocrecom"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedIn />
                      </a>
                    </li>

                    <li className="list-inline-item mx-2">
                      <a href="mailto:support@glocre.com">
                        <EmailOutlinedIcon />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;